import React, {Component} from 'react';

import './RemedialTrainingResponse.scss';
import classNames from 'classnames';
import Checkbox from "../../../../shared/forms/Checkbox";
import {Input} from "reactstrap";

class QuestionFieldResponse extends Component {
  constructor(props) {
    super(props);

    this.state = {
        answerOptions: {},
        answer: null
    }
  }

  componentDidMount() {
    this.props.onValueChange && this.props.onValueChange(this.props.name, {
      answer: this.state.answer,
      isValid: true
    });

    let answerOptions = {};

    this.props.element.fields && this.props.element.fields.answers && this.props.element.fields.answers.reduce((acc, answer) => {
      if (this.props.value.answer == answer) {
        answerOptions[answer] = true;
      } else {
        answerOptions[answer] = false;
      }

      return acc;
    }, []);

    this.setState({
      answerOptions,
      answer: this.props.value.answer
    });
  }

  get isEdit() {
    return this.props.isEdit !== false
  }

  handleCheck(e) {
    let {name} = e.target;
    let answerOptions = {};
    let answer = null;
    let value = true;

    this.props.element.fields.answers.reduce((acc, answer) => {
      if (answer === name) {
        value = !this.state.answerOptions[answer]
      }

      answerOptions[answer] = false;

      return acc;
    }, []);

    answerOptions[name] = value;
    if (value) {
      answer = name;
    }

    this.setState({answerOptions, answer});

    this.props.onValueChange(this.props.name, {
      answer,
      isValid: true
    });
  }

  handleChange(answer) {
    this.props.onValueChange(this.props.name, {
      answer,
      isValid: true
    });
  }

  render() {
    return (
      <div className={classNames({
        "remedial-training-response": true,
        'dynamic-report-item': true,
        'preview': !this.isEdit
      })}>
        <div className="remedial-training-title question">
          {this.props.element.form_title}
        </div>

        {this.props.element.fields && this.props.element.fields.subtitle &&
        <div>
          {this.props.element.fields.subtitle}
        </div>
        }

        <div className="remedial-training-response-item">
          {this.isEdit && this.props.element.dropdown && this.props.element.fields && <Input
            className="select-shift"
            name="shift"
            onChange={event => this.handleChange(event.target.value)}
            type="select"
            value={this.state.answer}
          >
            <option key="" value="" ></option>
            {this.props.element.fields.answers.map((el) => (
              <option
                key={el}
                value={el}
              >
                {el}
              </option>
            ))}
          </Input>}
          {this.isEdit && !this.props.element.dropdown && this.props.element.fields && this.props.element.fields.answers.map((el) => (
            <div key={el}>
              <Checkbox
                key={el}
                name={el}
                label={el}
                checked={this.state.answerOptions[el]}
                onChange={(e) => this.handleCheck(e)}
              />
            </div>
          ))}

          {!this.isEdit &&
          <div className="field field-with-icon" style={{display: 'flex', alignItems: 'center', lineHeight: '1'}}>
            {this.state.answer && <i className="fa fa-check-square-o"/>}
            {this.state.answer || 'N/R'}
          </div>
          }
        </div>
      </div>
    )
  }
}

export default QuestionFieldResponse;
